import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.group.list');
import { OnInit, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-group-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.group.list/view.scss */
/* src/app/portal.gsdcuser.group.list/view.scss: no such file or directory */`],
})
export class PortalGsdcuserGroupListComponent implements OnInit {

    public groups: any = [];
    public piGroups: any[] = [];
    public piGroupsFailed = false;
    public piGroupsLoading = false;
    public loading = true;
    public loadFailed = false;
    public submittingJoinRequest = false;
    public availableLoading = false;
    public availableFailed = false;
    private returnFocus: HTMLElement | null = null;

    // 신규 그룹 생성
    public groupName: string = '';
    public groupDescription: string = '';
    public createOpen: boolean = false;
    public isServiceManager: boolean = false;
    public submittingGroupRequest: boolean = false;

    // 그룹 추가 가입
    public selectedGroup: string = '';
    public selectedRepresentative: string = '';
    public availableGroups: any[] = [];
    public availableRepresentatives: any[] = [];
    public joinOpen: boolean = false;
    public representativesLoading = false;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private element: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        this.isServiceManager = this.service.auth.session?.role === 'manager';
        await this.load();
        await this.loadPiGroups();
    }

    public async load() {
        this.loading = true;
        this.loadFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("load", {}, { timeout: 15000 });
            if (code !== 200 || !Array.isArray(data)) throw new Error('load');
            this.groups = data;
        } catch (_) {
            this.loadFailed = true;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadPiGroups() {
        // Service managers assign PIs from Community management.
        if (this.isServiceManager) {
            this.piGroups = [];
            this.piGroupsFailed = false;
            this.piGroupsLoading = false;
            return;
        }
        if (this.piGroupsLoading) return;
        this.piGroupsLoading = true;
        this.piGroupsFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('pi_groups');
            if (code != 200 || !Array.isArray(data?.groups)) throw new Error('load');
            this.piGroups = data.groups;
        } catch (_) {
            this.piGroups = [];
            this.piGroupsFailed = true;
        } finally {
            this.piGroupsLoading = false;
            await this.service.render();
        }
    }

    private async focusDialog() {
        await this.service.render();
        this.element.nativeElement.querySelector('.gl-dialog input:not(:disabled), .gl-dialog button:not(:disabled)')?.focus();
    }
    public modalKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            if (this.createOpen) this.closeCreate();
            else this.closeJoin();
        }
        if (event.key !== 'Tab') return;
        const dialog = event.currentTarget as HTMLElement;
        const controls = Array.from(dialog.querySelectorAll<HTMLElement>('button, input, select, textarea, a[href], [tabindex]'))
            .filter(el => !el.matches(':disabled') && el.tabIndex >= 0 && el.getClientRects().length > 0);
        const first = controls[0], last = controls[controls.length - 1];
        if (!first) { event.preventDefault(); dialog.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
            event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
        }
    }
    private restoreFocus() {
        if (this.returnFocus?.isConnected) this.returnFocus.focus();
        this.returnFocus = null;
    }
    // 신규 그룹 생성
    public async create() {
        this.returnFocus = document.activeElement as HTMLElement;
        this.createOpen = true;
        await this.focusDialog();
    }
    public async closeCreate() {
        if (this.submittingGroupRequest) return;
        this.createOpen = false;
        this.groupName = "";
        this.groupDescription = "";
        await this.service.render();
        this.restoreFocus();
    }
    public async submitGroupRequest() {
        if (this.submittingGroupRequest) return;
        if (!this.groupName || !this.groupDescription) {
            await this.service.alert.error("그룹 이름과 설명을 입력해 주세요.");
            return;
        }

        const confirmMessage = this.isServiceManager
            ? "신규 그룹을 바로 생성하시겠습니까?"
            : "신규 그룹 생성을 요청하시겠습니까?";
        const confirmed = await this.service.alert.success(confirmMessage, "취소");

        // 사용자가 확인 버튼을 클릭한 경우에만 진행
        if (!confirmed) return;
        this.submittingGroupRequest = true;
        this.service.loading.show(); // 로딩 시작
        await this.service.render();

        let response: any;
        try {
            response = await wiz.call("submit_group_request", {
                name: this.groupName,
                description: this.groupDescription
            });
        } catch (error) {
            response = {
                code: 500,
                data: { message: "그룹 생성 처리 중 오류가 발생했습니다." }
            };
        } finally {
            this.service.loading.hide(); // 로딩 종료
            this.submittingGroupRequest = false;
            await this.service.render();
        }

        const { code, data, message } = response;
        const resultMessage = typeof data === 'string' ? data : data?.message;

        if (code === 200) {
            await this.service.alert.success(resultMessage || "그룹 생성 요청이 처리되었습니다.");
            await this.closeCreate();
            if (data?.created_directly) await this.load();
        } else {
            await this.service.alert.error(resultMessage || message || "그룹 생성 요청에 실패했습니다.");
        }
    }

    // 그룹 추가 가입
    public async join() {
        this.returnFocus = document.activeElement as HTMLElement;
        this.selectedGroup = '';
        this.representativesLoading = false;
        this.selectedRepresentative = '';
        this.availableGroups = [];
        this.availableRepresentatives = [];
        this.joinOpen = true;
        const loading = this.loadAvailableGroups();
        await this.focusDialog();
        await loading;
    }
    public async loadAvailableGroups() {
        if (this.availableLoading) return;
        this.availableLoading = true;
        this.availableFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_available_groups", {}, { timeout: 15000 });
            if (code !== 200 || !Array.isArray(data)) throw new Error('load');
            if (this.joinOpen) this.availableGroups = data;
        } catch (_) {
            if (this.joinOpen) this.availableFailed = true;
        } finally {
            this.availableLoading = false;
            await this.service.render();
        }
    }
    public async closeJoin() {
        if (this.submittingJoinRequest) return;
        this.joinOpen = false;
        this.selectedGroup = '';
        this.representativesLoading = false;
        this.selectedRepresentative = '';
        this.availableGroups = [];
        this.availableRepresentatives = [];
        await this.service.render();
        this.restoreFocus();
    }
    // 그룹 추가 가입 -> 그룹 선택
    public async loadRepresentatives() {
        const groupId = this.selectedGroup;
        this.selectedRepresentative = '';
        this.availableRepresentatives = [];
        if (!groupId || this.availableGroups.find(group => group.id === groupId)?.join_open === 'N') return;
        this.representativesLoading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_group_representatives", { group_id: groupId });
            if (!this.joinOpen || this.selectedGroup !== groupId) return;
            if (code !== 200) {
                this.selectedGroup = '';
                await this.service.alert.error(data?.message || data || "대표자 목록을 불러오는 중 오류가 발생했습니다.");
                return;
            }
            this.availableRepresentatives = data;
        } catch (_) {
            if (this.joinOpen && this.selectedGroup === groupId) {
                this.selectedGroup = '';
                await this.service.alert.error("대표자 목록을 불러오는 중 오류가 발생했습니다.");
            }
        } finally {
            if (!this.selectedGroup || this.selectedGroup === groupId) this.representativesLoading = false;
            await this.service.render();
        }
    }
    // 그룹 추가 가입 -> 요청 제출
    public async submitJoinRequest() {
        if (this.submittingJoinRequest) return;
        if (!this.selectedGroup || !this.selectedRepresentative || this.representativesLoading) return;
        this.submittingJoinRequest = true;
        const payload = { group_id: this.selectedGroup, request_pi: this.selectedRepresentative };
        let submitted = false;
        let succeeded = false;
        let message = '';
        try {
            await this.service.render();
            const confirmed = await this.service.alert.success("선택한 그룹에 추가 가입 요청을 하시겠습니까?", "취소");
            if (!confirmed) return;
            submitted = true;
            this.service.loading.show();
            const response = await wiz.call("submit_join_request", payload, { timeout: 30000 });
            if (typeof response?.code !== 'number') throw new Error('unknown result');
            succeeded = response.code === 200;
            message = response.data?.message || (typeof response.data === 'string' ? response.data : response.message)
                || (succeeded ? "그룹 추가 가입 요청이 성공적으로 제출되었습니다." : "그룹 추가 가입 요청에 실패했습니다.");
        } catch (_) {
            message = "처리 결과를 확인하지 못했습니다. 신청·승인 내역을 확인한 후 다시 시도해주세요.";
        } finally {
            if (submitted) this.service.loading.hide();
            try {
                if (message) {
                    if (succeeded) await this.service.alert.success(message);
                    else await this.service.alert.error(message);
                }
            } finally {
                this.submittingJoinRequest = false;
                if (succeeded) await this.closeJoin();
                else await this.service.render();
            }
        }
    }
}

export default PortalGsdcuserGroupListComponent;